import { render, staticRenderFns } from "./specialNotes.vue?vue&type=template&id=545dcf88"
import script from "./specialNotes.vue?vue&type=script&lang=js"
export * from "./specialNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports